import TimeSeriesChart from '../../../../../widgets/immersive/vol-surface-timeseries/time-series-chart';
import './styles.scss';

const VolSurfaceTimeseriesChart = () => {
  return (
    <div className="vol-surface-timeseries-chart-container">
      <TimeSeriesChart />
    </div>
  );
};

export default VolSurfaceTimeseriesChart;
